/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2020-12-21 09:49:47
 * @LastEditors: 
 * @LastEditTime: 2021-09-01 15:43:58
 * @FilePath: \heshan_web\src\api\admin\userStation.js
 */
import request from '@/router/axios';
export function getPage(param) {
  return request({
    url: '/api/project/page',
    method: 'get',
    params: param
  });
}
export function setGateway(param) {
  return request({
    url: "/api/blade-user/grantProject",
    method: 'post',
    params: param
  });
} // 分配项目

export function grantProject(param) {
  return request({
    url: "/api/blade-user/grantProject",
    method: 'post',
    data: param
  });
} // 分配设备

export function distribute(param) {
  return request({
    url: "/api/device/distribute",
    method: 'post',
    data: param
  });
}